export default __webpack_public_path__ + "static/media/CE.08e9877c.svg";